export default "__VITE_ASSET__DolnnJuS__"